import CustomField from 'Types/customField';

export default CustomField.extend({
  value: undefined,
});